export default {
    select: 'select',
    add: 'add'
};


// WEBPACK FOOTER //
// ./src/components/common/selectionElementMode.js